export enum RR_TABLE_ACTION_BEHAVIOUR_TYPE {
  SHOW_MODAL,
  NAVIGATE_TO_URL,
  INLINE,
  NONE,
}
